import { SortOrder } from "antd/es/table/interface";

type IListDisciplinesValidOrderKey = 'name';

const tilePtBrMap: Record<IListDisciplinesValidOrderKey, string> = {
  name: 'Nome',
}

export const getOrderTitle = (
  order: SortOrder,
  titleKey: IListDisciplinesValidOrderKey
) => {
  const titlePtBr = tilePtBrMap[titleKey];

  if (order === null) {
    return `Ordenar ${titlePtBr} Crescente`;
  }
  if (order === 'ascend') {
    return `Ordenar ${titlePtBr} Decrescente`;
  }
  return `Desabilitar Ordenação ${titlePtBr}`;
}
